'use client';

import { useRouter } from 'next/navigation';

import { linkButtonTitles } from '@monoimin/intl';
import { FormButton, LinkButton, LinkButtonProps } from '@monoimin/atoms';
import { Locales } from '@monoimin/sb-types';

export const CarouselLinkButton = ({
  locale,
  href,
  children,
  className,
  size = 'default',
}: LinkButtonProps & { locale: Locales }) => {
  const router = useRouter();
  if (!href || href === '/') {
    return null;
  }
  if (href.includes('?')) {
    return (
      <FormButton
        variant='secondary'
        size={size}
        className={className}
        onClick={() => router.push(href)}
      >
        {children || linkButtonTitles[locale]}
      </FormButton>
    );
  }
  return (
    <LinkButton
      href={href}
      className={className}
      variant='secondary'
      size={size}
    >
      {children || linkButtonTitles[locale]}
    </LinkButton>
  );
};
